import { render, staticRenderFns } from "./coursewareList.vue?vue&type=template&id=5ff08aea&scoped=true&"
import script from "./coursewareList.vue?vue&type=script&lang=js&"
export * from "./coursewareList.vue?vue&type=script&lang=js&"
import style0 from "./coursewareList.vue?vue&type=style&index=0&id=5ff08aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff08aea",
  null
  
)

export default component.exports